import { useSyncExternalStore } from 'react';
import { getLegKickUiSnapshot, subscribeLegKickUi } from '../../state/legKickUiStore.ts';
import { LEG_KICK_DOM } from './legKickDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function LegKickGameOver() {
  const d = LEG_KICK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeLegKickUi,
    getLegKickUiSnapshot,
    getLegKickUiSnapshot,
  );

  const isDuo = s.split && s.player1Score !== null && s.player2Score !== null;

  let winner: 'p1' | 'p2' | 'tie' | null = null;
  if (isDuo) {
    if (s.player1Score! > s.player2Score!) winner = 'p1';
    else if (s.player2Score! > s.player1Score!) winner = 'p2';
    else winner = 'tie';
  }

  function panelClass(player: 'p1' | 'p2'): string {
    if (winner === 'tie') return 'lk-go__panel lk-go__panel--tie';
    if (winner === player) return 'lk-go__panel lk-go__panel--winner';
    return 'lk-go__panel lk-go__panel--loser';
  }

  return (
    <div id={d.gameOverRoot} className="leg-kick-gameover" hidden={!s.gameOverVisible}>
      {isDuo ? (
        <div className="lk-go__duo">
          <div className={panelClass('p1')}>
            {winner === 'p1' && <div className="lk-go__crown" aria-hidden>🏆</div>}
            <div className="lk-go__player-name">P1</div>
            <div className="lk-go__player-score">{s.player1Score}</div>
            {winner === 'p1' && <div className="lk-go__winner-label">{t('game.winner')}</div>}
            {winner === 'tie' && <div className="lk-go__tie-label">{t('game.tie')}</div>}
          </div>

          <div className={panelClass('p2')}>
            {winner === 'p2' && <div className="lk-go__crown" aria-hidden>🏆</div>}
            <div className="lk-go__player-name">P2</div>
            <div className="lk-go__player-score">{s.player2Score}</div>
            {winner === 'p2' && <div className="lk-go__winner-label">{t('game.winner')}</div>}
            {winner === 'tie' && <div className="lk-go__tie-label">{t('game.tie')}</div>}
          </div>
        </div>
      ) : (
        <>
          <h2 className="leg-kick-gameover__title">{t('game.game_over')}</h2>
          <div className="leg-kick-gameover__score">{t('game.score')} {s.score}</div>
        </>
      )}
    </div>
  );
}
